module.exports = __webpack_public_path__ + "7df0a0b5215cc6aa264a7dc62a5017a6.MP3";